import { Injectable } from '@angular/core';
import { format as formatDate, toZonedTime } from 'date-fns-tz';

@Injectable({
  providedIn: 'root',
})
export class DatetimeService {
  getUserTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  formatDateInUserTimeZone(date: string | Date, format: string): string {
    const userTimeZone = this.getUserTimeZone();
    const utcDate = new Date(date.toString().endsWith('Z') ? date : `${date}Z`);
    const zonedDate = toZonedTime(utcDate, userTimeZone);
    return formatDate(zonedDate, format, { timeZone: userTimeZone });
  }

  formatDate(date: string | Date, format: string): string {
    return formatDate(date, format);
  }

  getLocalTime(format: string): string {
    const userTimeZone = this.getUserTimeZone();
    const zonedDate = toZonedTime(new Date(), userTimeZone);
    return formatDate(zonedDate, format, { timeZone: userTimeZone });
  }

  getUTCTime() {
    const userTimeZone = this.getUserTimeZone();
    const zonedDate = toZonedTime(new Date(), userTimeZone);
    return zonedDate.toISOString();
  }
}
